var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fit" },
    [
      _c("DocumentGrid", {
        attrs: { entityItemId: _vm.classId, deletable: _vm.canDelete }
      }),
      _vm.documentUploadState
        ? _c("document-upload", {
            attrs: { hideEntity: _vm.hideEntity, entityItemId: _vm.classId }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }